const formatNumber = (input, decimalPlaces, locale) => {
    if (input == null || input === '') return '0';

    const normalized = String(input).replace(',', '.');

    const number = parseFloat(normalized);
    if (isNaN(number)) return '0';

    return number.toLocaleString(locale || 'pt-BR', {
        maximumFractionDigits: decimalPlaces,
        minimumFractionDigits: decimalPlaces
    });
};

const maxFormatNumber = (input, decimalPlaces, locale) => {
    if (!input) return '-';
    input = parseFloat(input);
    return input.toLocaleString(locale || 'pt-BR', {
        maximumFractionDigits: decimalPlaces
    });
};

const minFormatNumber = (input, decimalPlaces, locale) => {
    if (input == null || input === '') return '-';
    let formattedInput = input;

    if (typeof input === 'string') {
        formattedInput = input
            .trim()
            .replace(/\./g, '')
            .replace(',', '.');
    }

    input = parseFloat(formattedInput);
    return input.toLocaleString(locale, {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces
    });
};

const formatNumberUs = (input, decimalPlaces) => {
    if (!input) {
        return '0';
    }

    const inputString = String(input);
    if (inputString.includes('.')) {
        let n = inputString.split('.', decimalPlaces);
        if (n.length > 1) {
            input =
                n[0] +
                '.' +
                n[1]
                    .substr(0, n[1].length - (n[1].length - decimalPlaces))
                    .padEnd(decimalPlaces, '0');
        } else {
            input = n[0];
        }
    }
    const options = {
        style: 'decimal',
        currency: 'BRL'
    };
    const formatNumber = new Intl.NumberFormat('en-US', options);
    return formatNumber.format(input).replace(/,/g, '.');
};

const formatProdutividade = produtividade => {

    if (!produtividade) return null;

    const options = {
        style: 'decimal',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    };

    const formatNumber = new Intl.NumberFormat('pt-BR', options);
    const resultado = Number.parseFloat(produtividade);

    if (resultado === 0) {
        return '-';
    }

    const variacao = 0.05; // 5%

    return `${formatNumber.format(
        resultado - resultado * variacao
    )} a ${formatNumber.format(resultado + resultado * variacao)}`;
};

const documentoFormatToNumeral = documento => {
    const value = documento.replace(/[.\-/]/g, '').toUpperCase();
    if (
        value &&
        (value.length === 11 || value.length === 14 || value.length === 8 || value.length === 9)
    ) {
        return value;
    }

    return documento;
};

const numeralStringFormatToDocumento = (numeralString, tipoDocumento) => {
    if (!numeralString) return '';

    if (tipoDocumento && ['CUIT', 'DNI', 'CUIT/DNI'].includes(tipoDocumento.toUpperCase())) {
        const clean = String(numeralString).replace(/\D/g, '');
        return clean.length === 11 ? mascaraCUIT(clean) : clean;
    }

    if (tipoDocumento && tipoDocumento.toUpperCase() === 'RUC') {
        const clean = String(numeralString).replace(/\D/g, '');
        return clean.length >= 3 ? mascaraRuc(clean) : clean;
    }

    if (numeralString.includes('X')) {
        numeralString = removerPontuacaoDocumentoLgpd(numeralString);
    }

    if (numeralString.length === 11) {
        if (numeralString.includes('X')) {
            return mascaraCpfLgpd(numeralString);
        } else {
            return mascaraCpf(numeralString);
        }
    } else if (numeralString.length === 14) {
        return mascaraCnpj(numeralString);
    } else if (numeralString.length === 8 || numeralString.length === 9) {
        return mascaraRuc(numeralString);
    } else {
        return numeralString;
    }
};

const localDateToDatePicker = (date) => {
    return new Date(
        date.year,
        date.monthValue - 1,
        date.dayOfMonth,
        12, 0, 0, 0
    );
};

function mascaraCpf(valor) {
    return valor
        .replace(/[^\w\s]/gi, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2')
        .replace(/^(-\d{2})(\d)$/, '$1');
}

function mascaraCpfLgpd(valor) {
    return valor.substring(0, 3) + '.' + valor.substring(3, 6) + '.' + valor.substring(6, 9) + '-' + valor.substring(9, 11);
}

function mascaraCnpj(valor) {
    const clean = valor.replace(/[.\-/]/g, '').toUpperCase();
    if (clean.length !== 14) {
        return valor;
    }

    return `${clean.slice(0, 2)}.${clean.slice(2, 5)}.${clean.slice(5, 8)}/${clean.slice(8, 12)}-${clean.slice(12, 14)}`;
}

function mascaraRuc(valor) {
    const string = String(valor).replace(/\D/g, '');

    const partes = [
        string.substring(0, string.length - 1),
        string.substring(string.length - 1, string.length)
    ];

    return partes.join('-');
}

function mascaraCUIT(valor) {
  const clean = valor.replace(/\D/g, '');
  // 2 dígitos + 8 dígitos + 1 dígito verificador
  return clean.replace(/^(\d{2})(\d{8})(\d)$/, '$1-$2-$3');
}

function utf8Decode(utf8String) {
    // eslint-disable-next-line eqeqeq
    if (typeof utf8String != 'string') {
        throw new TypeError('parameter ‘utf8String’ is not a string');
    }
    const unicodeString = utf8String
        .replace(
            /[\u00e0-\u00ef][\u0080-\u00bf][\u0080-\u00bf]/g,
            function (c) {
                var cc =
                    ((c.charCodeAt(0) & 0x0f) << 12) |
                    ((c.charCodeAt(1) & 0x3f) << 6) |
                    (c.charCodeAt(2) & 0x3f);
                return String.fromCharCode(cc);
            }
        )
        .replace(/[\u00c0-\u00df][\u0080-\u00bf]/g, function (c) {
            var cc = ((c.charCodeAt(0) & 0x1f) << 6) | (c.charCodeAt(1) & 0x3f);
            return String.fromCharCode(cc);
        });
    return unicodeString;
}

function formatCar(valor) {
    if (!valor) return;
    return valor
        .replace(/[^\w\s]/gi, '')
        .replace(/(\w{2})(\w)/, '$1-$2')
        .replace(/(\w{7})(\w)/, '$1-$2')
        .replace(/(-\w{32})(\w)?/, '$1')
        .replace(/ /g, '')
        .toUpperCase();
}

function formatCodigoParcela(valor) {
    if (!valor) return;

    const string = valor.replace(/[^\w\s]/gi, '');

    const partes = [
        string.substring(0, 8),
        string.substring(8, 12),
        string.substring(12, 16),
        string.substring(16, 20),
        string.substring(20)
    ];
    return partes.join('-');
}

function formatCarEstadualMT(valor) {
    if (!valor) return;

    const string = valor.replace(/[^\w\s]/gi, '');

    const ano = string.length - 4;
    const partes = [
        string.substring(0, ano),
        string.substring(ano, string.length)
    ];
    return partes.join('/');
}

const numeralToCompactMonth = function (numeral) {
    numeral -= 1;

    const compactMonths = [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez'
    ];

    return compactMonths[numeral];
};

const dateStringToDayName = function (dateString) {
    const days = [
        'Domingo',
        'Segunda',
        'Terça',
        'Quarta',
        'Quinta',
        'Sexta',
        'Sábado'
    ];
    const date = new Date(dateString);
    date.setDate(date.getDate() + 1);
    return days[date.getDay()];
};

function converterDataFullParaDataBR(data) {
    if (!data || data === null || data === undefined) {
        return '- -';
    }
    const dataObjeto = new Date(data);
    const dia = String(dataObjeto.getDate()).padStart(2, '0');
    const mes = String(dataObjeto.getMonth() + 1).padStart(2, '0');
    const ano = dataObjeto.getFullYear();
    return `${dia}/${mes}/${ano}`;
}

function reduzirCar(car) {
    if (typeof car !== 'string') return;
    if (car.length < 14) return;

    return car.slice(0, 9) + '...' + car.slice(car.length - 4);
}

function formatarCEP(cep) {
    let cep_ = cep.replace(/\D/g, '');

    if (cep_.length !== 8) {
        return cep_;
    }

    return cep_.substring(0, 5) + '-' + cep_.substring(5);
}

function isEmpty(data) {
    if (data === undefined || data === '' || data === null) {
        return '- -';
    } else {
        return data;
    }
}

function removerPontuacaoDocumento(input) {
    if (input) {
        return input.replace(/[.\-/]/g, '').toUpperCase();
    }

    return input;
}

function removerPontuacaoDocumentoLgpd(input) {
    if (input) {
        return input.replaceAll('.', '').replace('-', '').replace('/', '');
    }

    return input;
}

const numeralStringFormatTocpfCnpj = numeralString => {
    if (!numeralString) return '';

    if (numeralString.length === 11) {
        return mascaraCpf(numeralString);
    } else if (numeralString.length === 14) {
        return mascaraCnpj(numeralString);
    } else if (numeralString.length === 8 || numeralString.length === 9) {
        return mascaraRuc(numeralString);
    } else {
        return numeralString;
    }
};

function formatarDocumentoInput(documento, maxLength = 14) {
    if (!documento) {
        return documento;
    }

    const clean = removerPontuacaoDocumento(documento).slice(0, maxLength);

    if (clean.length === 14 || (clean.length === 11 && /^\d{11}$/.test(clean))) {
        return numeralStringFormatTocpfCnpj(clean);
    }

    return clean;
}

function formatIntegerTwoDigits(input) {
    if (input <= 9) return '0' + input;
    return input;
}

function formatDateToISO(data) {
    if (!data) return null;
    const d = new Date(data);
    if (isNaN(d.getTime())) return null;
    const ano = d.getFullYear();
    const mes = String(d.getMonth() + 1).padStart(2, '0');
    const dia = String(d.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
}

function resolveFormattingLocale(userLocale) {
    return !userLocale ? navigator.language || navigator.userLanguage : userLocale;
}

function localDateTimeToString(input, userLocale = null, options = {}) {
    if (!input || typeof input !== 'object') return null;
    if (input.year == null || input.monthValue == null || input.dayOfMonth == null) return null;

    const y = Number(input.year);
    const m = Number(input.monthValue) - 1;
    const d = Number(input.dayOfMonth);
    const hh = Number(input.hour || 0);
    const mi = Number(input.minute || 0);
    const ss = Number(input.second || 0);

    if (![y, m + 1, d].every(n => Number.isFinite(n))) return null;

    const interpretAsUtc = Boolean(options && options.interpretAsUtc);
    const date = interpretAsUtc
        ? new Date(Date.UTC(y, m, d, hh, mi, ss))
        : new Date(y, m, d, hh, mi, ss);

    if (isNaN(date.getTime())) return null;

    const locale = resolveFormattingLocale(userLocale);

    return date.toLocaleString(locale, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    });
}

function splitApiDateTimeForTable(dateTimeFromApi, userLocale = null, options = {}) {
    if (!dateTimeFromApi) {
        return ['-', '-'];
    }
    const localizedDateTimeString = localDateTimeToString(dateTimeFromApi, userLocale, {
        interpretAsUtc: true,
        ...options
    });
    if (!localizedDateTimeString) {
        return ['-', '-'];
    }
    return localizedDateTimeString.split(', ');
}

function localDateToString(input) {
    if (!input || input.year == null || input.monthValue == null || input.dayOfMonth == null) return null;
    const day = String(input.dayOfMonth).padStart(2, '0');
    const month = String(input.monthValue).padStart(2, '0');
    return `${day}/${month}/${input.year}`;
}

function localDateToISO(input) {
    if (!input || input.year == null || input.monthValue == null || input.dayOfMonth == null) return null;
    const day = String(input.dayOfMonth).padStart(2, '0');
    const month = String(input.monthValue).padStart(2, '0');
    return `${input.year}-${month}-${day}`;
}

function dateTimeToLocaleString(originalDate, opts = {}) {
    const { assumeUtc = true, userLocale = null } = opts;
    if (!originalDate || typeof originalDate !== 'object') return null;

    const locale = resolveFormattingLocale(userLocale);
    const y = Number(originalDate.year);
    const m = Number(originalDate.monthValue);
    const d = Number(originalDate.dayOfMonth);
    const hh = Number(originalDate.hour || 0);
    const mm = Number(originalDate.minute || 0);
    const localeOpts = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: assumeUtc ? 'UTC' : undefined
    };

    if (![y, m, d].every(n => Number.isFinite(n))) return null;

    if (assumeUtc) {
        const utcMillis = Date.UTC(y, m - 1, d, hh, mm);
        return new Date(utcMillis).toLocaleString(locale, localeOpts);
    } else {
        return new Date(y, m - 1, d, hh, mm).toLocaleString(locale, localeOpts);
    }
}

function formatDate(date, format = 'YYYY-MM-DD') {
    if (!date) return null;
    const d = new Date(date);
    if (isNaN(d.getTime())) return null;

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    if (format === 'YYYY-MM-DD') {
        return `${year}-${month}-${day}`;
    }
    if (format === 'DD/MM/YYYY') {
        return `${day}/${month}/${year}`;
    }
    return d.toISOString();
}

export default {
    formatNumber,
    maxFormatNumber,
    minFormatNumber,
    formatNumberUs,
    formatProdutividade,
    documentoFormatToNumeral,
    numeralStringFormatToDocumento,
    utf8Decode,
    formatCar,
    formatCodigoParcela,
    formatCarEstadualMT,
    numeralToCompactMonth,
    dateStringToDayName,
    converterDataFullParaDataBR,
    formatDate,
    reduzirCar,
    formatarCEP,
    isEmpty,
    removerPontuacaoDocumento,
    removerPontuacaoDocumentoLgpd,
    numeralStringFormatTocpfCnpj,
    formatarDocumentoInput,
    formatIntegerTwoDigits,
    formatDateToISO,
    dateTimeToLocaleString,
    localDateTimeToString,
    splitApiDateTimeForTable,
    localDateToDatePicker,
    localDateToString,
    localDateToISO
};
